import * as React from "react";

const CompanyIconDefault = (props) => (
	// eslint-disable-next-line react/jsx-props-no-spreading
	<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
		<rect width={32} height={32} fill="#E8E7EA" rx={4} />
		<path
			fill="#8C8594"
			d="M4 5.37C4 4.612 4.613 4 5.37 4h13.26c.757 0 1.37.613 1.37 1.37v22.493a.137.137 0 0 1-.137.137H4.137A.137.137 0 0 1 4 27.863V5.37Z"
		/>
		<path
			fill="#E8E7EA"
			d="M13.5 21h-3a.5.5 0 0 0-.5.5V28h4v-6.5a.5.5 0 0 0-.5-.5Z"
		/>
		<rect width={3} height={3} x={14} y={16} fill="#E8E7EA" rx={0.4} />
		<rect width={3} height={3} x={7} y={16} fill="#E8E7EA" rx={0.4} />
		<rect width={3} height={3} x={14} y={11} fill="#E8E7EA" rx={0.4} />
		<rect width={3} height={3} x={7} y={11} fill="#E8E7EA" rx={0.4} />
		<rect width={3} height={3} x={14} y={6} fill="#E8E7EA" rx={0.4} />
		<rect width={3} height={3} x={7} y={6} fill="#E8E7EA" rx={0.4} />
		<path
			fill="#D1CED4"
			d="M20 14.886c0-.49.396-.886.886-.886h6.228c.49 0 .886.396.886.886V27.91c0 .05-.04.089-.089.089H20.09a.089.089 0 0 1-.089-.089V14.886Z"
		/>
		<path
			fill="#fff"
			d="M22.5 17.4c0-.22.18-.4.4-.4h2.2c.22 0 .4.18.4.4v2.2a.4.4 0 0 1-.4.4h-2.2a.4.4 0 0 1-.4-.4v-2.2ZM22.5 22.4c0-.22.18-.4.4-.4h2.2c.22 0 .4.18.4.4v2.2a.4.4 0 0 1-.4.4h-2.2a.4.4 0 0 1-.4-.4v-2.2Z"
		/>
	</svg>
);
export default CompanyIconDefault;
